import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { api } from '@/services/api'

/** L'endpoint sta sotto /api/config, non sotto il /api/v1 di apiClient. */
const URL = '/api/config/versions'
const ROOT = { baseURL: '' }

export interface ModuleVersion {
  module: string
  /** healthy | degraded | unreachable | not_configured */
  status: string
  version?: string
  commit?: string
  /** Data del commit, YYYY-MM-DD. */
  commit_date?: string
  /** Solo ServiceManager: development | production. */
  environment?: string
  error?: string
}

export const useVersionStore = defineStore('version', () => {
  const modules = ref<ModuleVersion[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  /** ServiceManager risponde per se stesso, quindi e' sempre il primo. */
  const own = computed(() =>
    modules.value.find(m => m.module === 'ServiceManager') || null
  )

  /**
   * Il footer la chiede a ogni cambio pagina, la pagina Preferenze quando la
   * apri: senza `force` la prima risposta basta per tutta la sessione, perche'
   * la versione di un processo gia' avviato non cambia sotto i piedi. Con
   * `force` si ricontrollano gli altri due moduli, che possono essere stati
   * riavviati nel frattempo.
   */
  async function load(force = false) {
    if (loading.value) return
    if (modules.value.length && !force) return

    loading.value = true
    error.value = null
    try {
      const data = await api.get<{ modules: ModuleVersion[] }>(URL, ROOT)
      modules.value = data?.modules ?? []
    } catch (e: any) {
      error.value = e?.detail || e?.message || 'Versioni non disponibili'
      modules.value = []
    } finally {
      loading.value = false
    }
  }

  return { modules, loading, error, own, load }
})
